initDataMap = () => {
    if(!document.getElementById('karte')) {
        return;
    }

    var openedTooltip = null;
    $('.tabs-2 li a').on('click', function (event) {
        if (openedTooltip !== null) {
            openedTooltip.tooltip('close');
        }
    });

    $('.layer-station .bar i').click(function (event) {
        $('.layer-station').hide();
    });

    $('.map-options input').each(function (i, el) {
        if (!el.checked) {
            $('#karte use[data-type="' + $(el).attr('data-type') + '"]').hide();
        }
    });
    $(
        '#Hauptgewaesser path, #Nebengewaesser path, #Staedte polygon,#Staedte use, #Wetterstationen use,#Talsperren polygon,#Talsperren use, #Pegel use'
    ).on('click', function (event) {
        var url = '/Handler/MapData';
        var g = $(this);
        $('#svgInit').show();
        var dlg = $('.layer-station');
        dlg.hide();

        // Daten zur Station holen
        if (g.attr('data-id') === undefined) {
            errData(g);
        }
        $.ajax({
            cache: false,
            type: 'POST',
            url: url,
            dataType: 'json',
            data: { data: { sid: g.attr('data-id'), type: g.attr('data-type') } }
        }).done(function (data) {
            if (data !== -1) {
                var offset = $('#karte').offset();
                $(dlg.find('.lbl-abfluss')).text(data.text);
                if (data.referenz && data.referenz !== '') {
                    $(dlg.find('.row-0 div')).html(
                        '<i class="icon icon-' +
                            data.type +
                            '"></i> ' +
                            data.name +
                            '<br />Referenzstation: ' +
                            data.referenz
                    );
                } else {
                    $(dlg.find('.row-0 div')).html(
                        '<i class="icon icon-' + data.type + '"></i> ' + data.name
                    );
                }
                $(dlg.find('.val-abfluss')).text(data.value + ' ' + data.unit);
                $(dlg.find('.val-date')).text(data.date);
                if (data.statusPublic === 3) {
                    $(dlg.find('.lbl-warn')).text('');
                    $(dlg.find('.val-warn')).text('');
                } else {
                    $(dlg.find('.lbl-warn')).text('Warnstufe');
                    $(dlg.find('.val-warn')).text(function () {
                        if (data.statusPublic === -1) {
                            // Wenn kein �ffentlicher Status vorhanden ist, den errechneten nutzen
                            data.statusPublic = data.statusHvd;
                        }
                        switch (data.statusPublic) {
                            case 0:
                                return 'Normal';
                            case 1:
                                return 'Mittel';
                            case 2:
                                return 'Hoch';
                            default:
                                return 'Unbekannt';
                        }
                    });
                }
                if (data.path !== '') {
                    $(dlg.find('.val-link')).html(
                        '<i class="icon-right-dir"></i> <a href="' + data.path + '">Zur Station</a>'
                    );
                } else {
                    $(dlg.find('.val-link')).html(
                        'Keine Seite vorhanden: ' + data.type + ' ' + data.name
                    );
                }
                $(dlg.find('.title')).text(data.name);
                //dlg.css({'left':(event.pageX-offset.left+50) + 'px','top':(event.pageY-offset.top) + 'px'});
                dlg.css({ display: '' });
                //dlg.show();
                if (openedTooltip !== null) {
                    openedTooltip.tooltip('close');
                }
                g.tooltip({
                    track: true,
                    tooltipClass: 'hwp-tooltip',
                    content: function () {
                        var tt = $(this).attr('title');
                        return tt.replace('\\n', '<br />');
                    }
                });
                g.tooltip('open');
                openedTooltip = g;

                $('#svgInit').hide();
            } else {
                errData(g);
            }
        });
        function errData(g) {
            $('#svgInit').hide();
            // alert("Keine Daten vorhanden!\nName:" + g.attr('title') + "\nType: " + g.attr('data-type') + "\nID: " + g.attr('data-id'));
            console.info(
                'Keine Daten vorhanden!\nName:' +
                    g.attr('title') +
                    '\nType: ' +
                    g.attr('data-type') +
                    '\nID: ' +
                    g.attr('data-id')
            );
        }
    });
    $('.map-options input').change(function (event) {
        var sType = $(this).attr('data-type');
        if (this.checked) {
            $('#karte use[data-type="' + sType + '"]').show();
        } else {
            $('#karte use[data-type="' + sType + '"]').hide();
            var $el = $(
                '#karte use[data-id="' +
                    $('#karte-drag').attr('data-id') +
                    '"][data-type="' +
                    $('#karte-drag').attr('data-type') +
                    '"]'
            );
            $el.show();
        }
    });

    /* Zoom */
    var mapZoomMax = 300;
    var mapZoomMin = 20;
    var map = $('#karte')[0];
    map.initHeight = $(map).height();
    map.initWidth = $(map).width();
    map.scale = 100;

    function updateMap() {
        var outer = $(map).parent();
        outer.css({ width: (map.initWidth / 100) * map.scale });
        outer.css({ height: (map.initHeight / 100) * map.scale });

        $('#slider-vertical').slider('value', map.scale);
    }
};

window.setTimeout(initDataMap, 200);
